import * as React from 'react';
import {useEffect, useState} from 'react';
import {FormattedMessage} from 'react-intl';

import './style.scss';

import {Button, ButtonColor, ButtonSize, ButtonType} from '@atoms/LinksAndButtons/Button';
import {Icon} from 'components/atoms/Media/Icon';

interface Props {
    id: string;
    onChange: (count: number) => void;
    value?: number;
    minValue?: number;
    maxValue?: number;
    maxValueAffix?: string;
}

export const Counter: React.FunctionComponent<Props> = ({id, onChange, value, minValue, maxValue, maxValueAffix}) => {
    const [count, setCount] = useState<number>(value ?? minValue ?? 0);

    useEffect(() => {
        if (value !== undefined) {
            setCount(value);
        }
    }, [value]);

    const add = () => {
        if (maxValue !== undefined && count >= maxValue) return;

        const newCount = count + 1;
        setCount(newCount);
        onChange(newCount);
    };

    const subtract = () => {
        if (minValue !== undefined && count <= minValue) return;

        const newCount = count - 1;
        setCount(newCount);
        onChange(newCount);
    };

    const renderValue = () => {
        if(maxValue && maxValueAffix && count === maxValue) return `${count}${maxValueAffix}`;

        return count;
    };

    return (
        <div className="counter">
            <Button
                buttonColor={ButtonColor.LIGHT} 
                buttonSize={ButtonSize.DEFAULT} 
                buttonType={ButtonType.DEFAULT}
                className="counter__button counter__subtract"
                onClick={subtract}
                icon={<Icon name="minus" />}
                ariaControls={id}
                iconBtn
            >
                <FormattedMessage id="jm.components.Counter.subtract" />
            </Button>
            <input
                id={id}
                type="text"
                className="counter__field"
                onChange={() => {}}
                value={renderValue()}
                tabIndex={-1}
            />
            <Button
                buttonColor={ButtonColor.LIGHT} 
                buttonSize={ButtonSize.DEFAULT} 
                buttonType={ButtonType.DEFAULT}
                className="counter__button counter__subtract"
                onClick={add}
                icon={<Icon name="plus" />}
                ariaControls={id}
                iconBtn
            >
                <FormattedMessage id="jm.components.Counter.add" />
            </Button>
        </div>
    )
};
